import React, { useState, useRef, useEffect } from 'react';
import { Tab, Tabs } from '@material-ui/core';
import { Person as ContactIcon, Assessment as ProjectIcon, People as GroupIcon } from '@material-ui/icons';
import AppHeader from '../AppHeader';
import SideMenuSearch from '../SideMenuSearch';
import styles from './index.module.scss';
import ResourceItem from '../ResourceItem';
import useWindowSize from '../../hooks/useWindowSize';

import { v4 as uuidv4 } from 'uuid';

const mockItems = [
    {
        id: uuidv4(),
        name: "Janet J.",
        initial: "J",
        datetimestamp: "2011-10-05T14:48:00.000Z",
        message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed volutpat suscipit lectus porttitor pharetra. Suspendisse et elit in urna elementum feugiat. Phasellus et consectetur dui, a egestas dolor. Duis odio augue, faucibus vitae bibendum et, sollicitudin vel quam. Nam semper mauris ex, commodo placerat enim porttitor ac. Aliquam congue elit vitae tortor gravida faucibus. Nulla finibus efficitur felis."
    },
    {
        id: uuidv4(),
        name: "Mathew J.",
        initial: "M",
        datetimestamp: "2011-10-05T14:48:00.000Z",
        message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed volutpat suscipit lectus porttitor pharetra. Suspendisse et elit in urna elementum feugiat. Phasellus et consectetur dui, a egestas dolor. Duis odio augue, faucibus vitae bibendum et, sollicitudin vel quam. Nam semper mauris ex, commodo placerat enim porttitor ac. Aliquam congue elit vitae tortor gravida faucibus. Nulla finibus efficitur felis."
    },
    {
        id: uuidv4(),
        name: "Leslie J.",
        initial: "L",
        datetimestamp: "2011-10-05T14:48:00.000Z",
        message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed volutpat suscipit lectus porttitor pharetra. Suspendisse et elit in urna elementum feugiat. Phasellus et consectetur dui, a egestas dolor. Duis odio augue, faucibus vitae bibendum et, sollicitudin vel quam. Nam semper mauris ex, commodo placerat enim porttitor ac. Aliquam congue elit vitae tortor gravida faucibus. Nulla finibus efficitur felis."
    },
    {
        id: uuidv4(),
        name: "Jim J.",
        initial: "J",
        datetimestamp: "2011-10-05T14:48:00.000Z",
        message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed volutpat suscipit lectus porttitor pharetra. Suspendisse et elit in urna elementum feugiat. Phasellus et consectetur dui, a egestas dolor. Duis odio augue, faucibus vitae bibendum et, sollicitudin vel quam. Nam semper mauris ex, commodo placerat enim porttitor ac. Aliquam congue elit vitae tortor gravida faucibus. Nulla finibus efficitur felis."
    },
    {
        id: uuidv4(),
        name: "Bob J.",
        initial: "B",
        datetimestamp: "2011-10-05T14:48:00.000Z",
        message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed volutpat suscipit lectus porttitor pharetra. Suspendisse et elit in urna elementum feugiat. Phasellus et consectetur dui, a egestas dolor. Duis odio augue, faucibus vitae bibendum et, sollicitudin vel quam. Nam semper mauris ex, commodo placerat enim porttitor ac. Aliquam congue elit vitae tortor gravida faucibus. Nulla finibus efficitur felis."
    },
];

const SideMenu = () => {
    const [activeTab, setActiveTab] = useState(0);

    const onChangeTab = (event: React.ChangeEvent<{}>, newTab: number) => {
        setActiveTab(newTab)
    }

    const topEl = useRef<HTMLDivElement>(null);
    const [resourceListHeight, setResourceListHeight] = useState<number|undefined>();
    const windowSize = useWindowSize();

    useEffect(() => {
        if (topEl && topEl.current && windowSize && windowSize.height) {
            const { bottom } = topEl.current.getBoundingClientRect();
            setResourceListHeight(windowSize.height - bottom);
        }
    }, [windowSize]);

    const [activeId, setActiveId] = useState<string|null>(null);
    const onClickItem = (id: string) => {
        setActiveId(id);
    }

    return (
        <div className={styles.container}>
            <div ref={topEl}>
                <AppHeader title="Ginger K."
                        subtitle="Project Manager"
                        avatarText="G"
                        menuItems={[
                            {label: "Account"},
                            {label: "Logout"}
                        ]}></AppHeader>
                <SideMenuSearch/>
                <Tabs className={styles.tabs} aria-label="tabs" onChange={onChangeTab} value={activeTab}>
                    <Tab icon={<ContactIcon/>} label="Contacts" />
                    <Tab icon={<GroupIcon/>} label="Groups" />
                    <Tab icon={<ProjectIcon/>} label="Projects" />
                </Tabs>
            </div>
            <div className={styles.resourceList} style={{height: resourceListHeight}}>
                {mockItems.map((item, i) => <ResourceItem key={i} 
                                                          onClick={() => onClickItem(item.id)}
                                                          isActive={activeId === item.id} 
                                                          item={item}/>)}
            </div>
        </div>
    );
};

export default SideMenu;